export const NWSApiUrl = 'https://api.weather.gov/'
export const categoryDayFetchUrl = 'https://mesonet.agron.iastate.edu/wx/afos/p.php?pil='

// Copied from https://www.weather.gov/source/lzk/catday.js?v=1653573814867
export const countyFireZoneToPILMap = {
	ARZ001: "FWFTSA",
	ARZ002: "FWFTSA",
	ARZ103: "FWFLZK",
	ARZ203: "FWFLZK",
	ARZ004: "FWFLZK",
	ARZ005: "FWFLZK",
	ARZ006: "FWFLZK",
	ARZ007: "FWFLZK",
	ARZ008: "FWFLZK",
	ARZ009: "FWFMEG",
	ARZ010: "FWFTSA",
	ARZ011: "FWFTSA",
	ARZ112: "FWFLZK",
	ARZ212: "FWFLZK",
	ARZ113: "FWFLZK",
	ARZ213: "FWFLZK",
	ARZ313: "FWFLZK",
	ARZ014: "FWFLZK",
	ARZ015: "FWFLZK",
	ARZ016: "FWFLZK",
	ARZ017: "FWFLZK",
	ARZ018: "FWFMEG",
	ARZ019: "FWFTSA",
	ARZ020: "FWFTSA",
	ARZ121: "FWFLZK",
	ARZ221: "FWFLZK",
	ARZ122: "FWFLZK",
	ARZ222: "FWFLZK",
	ARZ123: "FWFLZK",
	ARZ223: "FWFLZK",
	ARZ024: "FWFLZK",
	ARZ025: "FWFLZK",
	ARZ026: "FWFMEG",
	ARZ027: "FWFMEG",
	ARZ028: "FWFMEG",
	ARZ029: "FWFTSA",
	ARZ130: "FWFLZK",
	ARZ230: "FWFLZK",
	ARZ031: "FWFLZK",
	ARZ032: "FWFLZK",
	ARZ033: "FWFLZK",
	ARZ034: "FWFLZK",
	ARZ035: "FWFMEG",
	ARZ036: "FWFMEG",
	ARZ137: "FWFLZK",
	ARZ237: "FWFLZK",
	ARZ138: "FWFLZK",
	ARZ238: "FWFLZK",
	ARZ039: "FWFLZK",
	ARZ140: "FWFLZK",
	ARZ240: "FWFLZK",
	ARZ340: "FWFLZK",
	ARZ141: "FWFLZK",
	ARZ241: "FWFLZK",
	ARZ341: "FWFLZK",
	ARZ042: "FWFLZK",
	ARZ043: "FWFLZK",
	ARZ044: "FWFLZK",
	ARZ045: "FWFLZK",
	ARZ046: "FWFLZK",
	ARZ047: "FWFLZK",
	ARZ048: "FWFMEG",
	ARZ049: "FWFMEG",
	ARZ050: "FWFSHV",
	ARZ051: "FWFSHV",
	ARZ052: "FWFLZK",
	ARZ053: "FWFLZK",
	ARZ054: "FWFLZK",
	ARZ055: "FWFLZK",
	ARZ056: "FWFLZK",
	ARZ057: "FWFLZK",
	ARZ058: "FWFMEG",
	ARZ059: "FWFSHV",
	ARZ060: "FWFSHV",
	ARZ061: "FWFSHV",
	ARZ062: "FWFLZK",
	ARZ063: "FWFLZK",
	ARZ064: "FWFLZK",
	ARZ065: "FWFLZK",
	ARZ066: "FWFLZK",
	ARZ067: "FWFLZK",
	ARZ068: "FWFLZK",
	ARZ069: "FWFLZK",
	ARZ070: "FWFSHV",
	ARZ071: "FWFSHV",
	ARZ072: "FWFSHV",
	ARZ073: "FWFSHV",
	ARZ074: "FWFJAN",
	ARZ075: "FWFJAN"
};

// Copied from https://www.weather.gov/source/lzk/catday.js?v=1653573814867
export const countyFireZoneToNameMap = {
	ARZ001: "BENTON-",
	ARZ002: "CARROLL-",
	ARZ103: "BOONE COUNTY EXCEPT SOUTHWEST-",
	ARZ203: "BOONE COUNTY HIGHER ELEVATIONS-",
	ARZ004: "MARION-",
	ARZ005: "BAXTER-",
	ARZ006: "FULTON-",
	ARZ007: "SHARP-",
	ARZ008: "RANDOLPH-",
	ARZ009: "CLAY-",
	ARZ010: "WASHINGTON AR-",
	ARZ011: "MADISON-",
	ARZ112: "NEWTON COUNTY HIGHER ELEVATIONS-",
	ARZ212: "NEWTON COUNTY LOWER ELEVATIONS-",
	ARZ113: "SEARCY COUNTY LOWER ELEVATIONS-",
	ARZ213: "NORTHWEST SEARCY COUNTY HIGHER ELEVATIONS-",
	ARZ313: "EASTERN, CENTRAL, AND SOUTHERN SEARCY COUNTY HIGHER ELEVATIONS-",
	ARZ014: "STONE-",
	ARZ015: "IZARD-",
	ARZ016: "INDEPENDENCE-",
	ARZ017: "LAWRENCE-",
	ARZ018: "GREENE-",
	ARZ019: "CRAWFORD-",
	ARZ020: "FRANKLIN-",
	ARZ121: "SOUTHERN JOHNSON COUNTY-",
	ARZ221: "JOHNSON COUNTY HIGHER ELEVATIONS-",
	ARZ122: "SOUTHERN POPE COUNTY-",
	ARZ222: "POPE COUNTY HIGHER ELEVATIONS-",
	ARZ123: "SOUTHEAST VAN BUREN COUNTY-",
	ARZ223: "VAN BUREN COUNTY HIGHER ELEVATIONS-",
	ARZ024: "CLEBURNE-",
	ARZ025: "JACKSON-",
	ARZ026: "CRAIGHEAD-",
	ARZ027: "POINSETT-",
	ARZ028: "MISSISSIPPI-",
	ARZ029: "SEBASTIAN-",
	ARZ130: "WESTERN AND NORTHERN LOGAN COUNTY-",
	ARZ230: "SOUTHERN AND EASTERN LOGAN COUNTY-",
	ARZ031: "CONWAY-",
	ARZ032: "FAULKNER-",
	ARZ033: "WHITE-",
	ARZ034: "WOODRUFF-",
	ARZ035: "CROSS-",
	ARZ036: "CRITTENDEN-",
	ARZ137: "NORTHERN SCOTT COUNTY-",
	ARZ237: "CENTRAL AND SOUTHERN SCOTT COUNTY-",
	ARZ138: "NORTHWEST YELL COUNTY-",
	ARZ238: "YELL EXCLUDING NORTHWEST-",
	ARZ039: "PERRY-",
	ARZ140: "POLK COUNTY LOWER ELEVATIONS-",
	ARZ240: "NORTHERN POLK COUNTY HIGHER ELEVATIONS-",
	ARZ340: "SOUTHEAST POLK COUNTY HIGHER ELEVATIONS-",
	ARZ141: "CENTRAL AND EASTERN MONTGOMERY COUNTY-",
	ARZ241: "NORTHERN MONTGOMERY COUNTY HIGHER ELEVATIONS-",
	ARZ341: "SOUTHWEST MONTGOMERY COUNTY HIGHER ELEVATIONS-",
	ARZ042: "GARLAND-",
	ARZ043: "SALINE-",
	ARZ044: "PULASKI-",
	ARZ045: "LONOKE-",
	ARZ046: "PRAIRIE-",
	ARZ047: "MONROE-",
	ARZ048: "ST. FRANCIS-",
	ARZ049: "LEE AR-",
	ARZ050: "SEVIER-",
	ARZ051: "HOWARD-",
	ARZ052: "PIKE-",
	ARZ053: "CLARK-",
	ARZ054: "HOT SPRING-",
	ARZ055: "GRANT-",
	ARZ056: "JEFFERSON-",
	ARZ057: "ARKANSAS-",
	ARZ058: "PHILLIPS-",
	ARZ059: "LITTLE RIVER-",
	ARZ060: "HEMPSTEAD-",
	ARZ061: "NEVADA-",
	ARZ062: "DALLAS-",
	ARZ063: "CLEVELAND-",
	ARZ064: "LINCOLN-",
	ARZ065: "DESHA-",
	ARZ066: "OUACHITA-",
	ARZ067: "CALHOUN-",
	ARZ068: "BRADLEY-",
	ARZ069: "DREW-",
	ARZ070: "MILLER-",
	ARZ071: "LAFAYETTE-",
	ARZ072: "COLUMBIA-",
	ARZ073: "UNION-",
	ARZ074: "ASHLEY-",
	ARZ075: "CHICOT-"
}